import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

const useTrackEvent = <T extends TrackEventParameters<any, any>>(
    parameters: T,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.event, parameters, options);
};

export default useTrackEvent;
